// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"CJ-z","loadingMedia":"DJ-z","reviewsImagesAndVideos":"EJ-z","limitHeight":"FJ-z"};